import { useMemo } from 'react';
import { usePricingList } from '../../../hooks/pricing/usePricingList.js';
import PricingTable from '../../../components/tables/pricing/PricingTable.jsx';
import SearchBar from '../../../components/utils/SearchBar.jsx';
import Pagination from '../../../components/utils/Pagination.jsx';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';

export default function ListPricing() {
    const {
        price,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        success,
        setSuccess,
        error,
        setError,
        handleSort,
        sortField,
        sortOrder   
    } = usePricingList();

    // FILTRO POR BÚSQUEDA
    const filteredPrices = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return price.filter(pricing => {
            return (
                (pricing.name || '').toLowerCase().includes(search) ||
                (pricing.value || '').toLowerCase().includes(search)
            );
        });
    }, [price, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPrices = filteredPrices.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'><i className="bi bi-currency-dollar me-4"></i> Lista de precios</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />
                <PricingTable
                    price={currentPrices}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                />
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredPrices.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />
                <SuccessModal show={!!success} message={success} onClose={() => setSuccess('')} />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}